import React from 'react';
import { Sparkles } from 'lucide-react';

const ComingSoon = ({ title }) => (
  <div className="flex flex-col items-center justify-center py-24 text-center px-6" data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="w-16 h-16 rounded-full bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center mb-4">
      <Sparkles size={28} className="text-zinc-500" />
    </div>
    <h1 className="text-xl font-semibold mb-1">{title}</h1>
    <p className="text-sm text-zinc-500 max-w-md">Coming soon.</p>
  </div>
);

export default ComingSoon;
